import { RoleAlertConfig } from './interfaces';

export const roleAlertConfig: Record<string, RoleAlertConfig> = {
	CONSULTANT: {
		alertKey: 'ExclusiveBasket',
		alertDays: 45,
		id: (userId) => `Consultant:${userId}`,
	},
	SUPERVISOR: {
		alertKey: 'ExclusiveBasket',
		alertDays: 45,
		id: (userId) => `Supervisor:${userId}`,
	},
	DEFAULT: {
		alertKey: '',
		alertDays: 0,
		id: () => '',
	},
};
